var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"color":_vm.color,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }